import './PrivacyPolicy.css';
const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-hero">
        <h1>Privacy Policy</h1>
        <p>Your privacy matters to us at RoomBuddy</p>
      </div>
      <div className="privacy-content">
        <div className="privacy-section">
          <h2>Overview</h2>
          <p>
            At RoomBuddy, we respect your privacy. This Privacy Policy explains
            what information we collect, why we collect it, how we use it and the
            choices you have. By using RoomBuddy or our services, you agree to the
            collection and use described here.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <h3>1. Information you provide</h3>
          <p>
            When you create an account, list a property, request a visit or contact an
            owner, we may collect personal information such as your name, phone number,
            email address, profile photo, and communication content.
          </p>
          <h3>2. Automatically collected data</h3>
          <p>
            We automatically collect device information, usage data, and (with permission)
            location data to improve search results and nearby listings.
          </p>
          <h3>3. Photos &amp; media</h3>
          <p>
            Photos and videos uploaded for listings are stored and visible to users.
          </p>
        </div>
        <div className="privacy-section">
          <h2>How We Use Your Data</h2>
          <ul className="privacy-check-list">
            <li>To provide &amp; improve RoomBuddy features</li>
            <li>To match you with relevant properties &amp; services</li>
            <li>To process bookings &amp; payments</li>
            <li>To communicate updates &amp; alerts</li>
            <li>To prevent fraud &amp; comply with law</li>
          </ul>
        </div>
        <div className="privacy-section">
          <h2>Sharing &amp; Third Parties</h2>
          <p>
            Data may be shared with service providers, payment processors,
            logistics partners, and as required by law — under strict confidentiality.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Location &amp; Map Data</h2>
          <p>
            Location is used only to improve results. You may disable it anytime.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Cookies &amp; Tracking</h2>
          <p>We use cookies for login, preferences and analytics.</p>
        </div>
        <div className="privacy-section">
          <h2>Security</h2>
          <p>
            We apply industry-standard security, but no system is 100% secure. Please
            contact us if you suspect an issue.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>
            RoomBuddy is not intended for users under 16. We delete information if notified.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Your Rights</h2>
          <p>
            You may review, update or delete your profile information anytime.
          </p>
        </div>
        <div className="privacy-section">
          <h2>Contact &amp; Updates</h2>
          <div className="privacy-highlight">
            <p>
              For privacy concerns, email{' '}
              <a href="mailto:support@roombuddy.in">support@roombuddy.in</a>
            </p>
            <p>We will notify users if this policy changes.</p>
          </div>
        </div>
        <div className="privacy-updated">
          <span>Last Updated: Dec 11, 2025</span>
        </div>
        <div style={{ textAlign: 'center' }}>
          <a href="/" className="privacy-back">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};
export default PrivacyPolicy;